import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateStudentBoardService=async(data)=>{
    try {
        const result = await post(`api/admin/section_board/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateStudentBoardService=async(data,id)=>{
    try {
        const result = await put(`api/admin/section_board/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetStudentBoardService=async()=>{
    try {
        const result = await get(`api/admin/section_board/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteStudentBoardService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/section_board/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

